module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Polityka prywatności",
	"footer.privacy.url": "https://www.grohe.pl/pl_pl/grohe/ochrona-prywatnosci.html",
	"footer.disclaimer.text": "Zastrzeżenia prawne",
	"footer.disclaimer.url": "https://www.grohe.pl/pl_pl/grohe/zastrzezenia-prawne.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Konfigurator systemów kuchennych GROHE",
	"homepage.introtext": "Wystarczy, że odpowiesz na kilka pytań, a konfigurator dopasuje najlepszy dla Ciebie system kuchenny z oferty GROHE.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Wróć  do strony głównej",
	"configurator.button.seeResults": "Zobacz wyniki",
	"question1.question": "Czy posiadasz doprowadzenie zimnej i ciepłej wody w swojej kuchni?",
	"question1.option1.text": "Posiadam doprowadzenie zarówno zimnej jak i ciepłej wody w mojej kuchni.",
	"question1.option2.text": "Posiadam doprowadzenie tylko zimnej wody",
	"question2.question": "Jakiego rodzaju wody poszukujesz?",
	"question2.option1.text": "Wrzącej wody do przygotowywania posiłków i napojów.",
	"question2.option2.text": "Schłodzonej i gazowanej wody do picia ",
	"question2.option3.text": "Zarówno schłodzonej i gazowanej, jak i wrzącej wody",
	"question3.question": "Czy chcesz zatrzymać istniejącą baterię kuchenną?",
	"question3.option1.text": "Tak, chcę ją zatrzymać.",
	"question3.option2.text": "Chcę zainstalować nową baterię",
	"question4.question": "Co powinno być Twoją główną baterią kuchenną?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Jaki design wylewki wolisz?",
	"question5.option1.text": "Wylewka w kształcie litery L",
	"question5.option2.text": "Wylewka w kształcie U",
	"question5.option3.text": "Wylewka w kształcie C",
	"question6.question": "Jaką powłoką powinna być pokryta Twoja bateria?",
	"question6.option1.text": "Chromem",
	"question6.option2.text": "Supersteel",
	"question7.question": "Który rozmiar bojlera wybierasz? ",
	"question7.option1.text": "W rozmiarze M (3 litry wody)",
	"question7.option2.text": "W rozmiarze L (5.5 litra wody)",
	"results.title": "{productGroupsCount, plural, \none {Twój wynik} \nother {Twoje wyniki}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "W celu przeprowadzenia prawidłowej instalacji, będzie potrzebować również:",
	"results.newConfiguration.title": "Czy chcesz skonfigurować nowy system?",
	"results.newConfiguration.buttonText": "Skonfiguruj nowy system",
	"results.product.number": "Nr produktu: #{number}",
	"results.product.button.productInformation": "Informacja o produkcie",
	"results.product.button.dealerLocator": "Znajdź salon sprzedaży",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informacja o produkcie",
	"results.product.dealer": "Znajdź salon sprzedaży",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.pl_pl.json
// module id = 783
// module chunks = 0